import React from "react";
import LearningCard from "./Learning-card";
import OnsiteImg from "../../assets/onsite-learning.png";
import OnlineImg from "../../assets/online-learning.png";

const defaultModes = [
  {
    id: 1,
    title: "Onsite Learning",
    description:
      "Join us at our state-of-the-art training center for immersive, face-to-face instruction and networking.",
    footer: "Ogbomoso & Lagos Centers",
    image: OnsiteImg,
    type: "onsite",
  },
  {
    id: 2,
    title: "Online Learning",
    description:
      "Learn from anywhere in the world with live instructor-led sessions and recorded modules accessible 24/7.",
    footer: "Worldwide Access",
    image: OnlineImg,
    type: "online",
  },
];

const LearningModesSection = ({
  title = "Flexible",
  highlight = "Learning",
  subtitle = "Choose the path that fits your schedule.",
  modes = defaultModes,
  sectionClassName = "bg-[#F5F6F8] md:py-20 py-6 px-4 sm:px-6 lg:px-16",
}) => {
  return (
    <section className={sectionClassName}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 px-2 sm:px-0">
          <h2 className="text-3xl font-bold text-[#081B33] mb-3 sm:text-4xl md:text-5xl">
            {title} <span className="text-[#EFA632]">{highlight}</span> Modes
          </h2>

          <p className="text-gray-500 text-base sm:text-lg">{subtitle}</p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {modes.map((mode) => (
            <LearningCard
              key={mode.id}
              {...mode}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LearningModesSection;
